export default __webpack_public_path__ + "static/media/Alchemy Chains 3.49eea40f.png";